import { Button, message, Popconfirm } from 'antd';
import React from 'react'

const DeleteClient = (props) => {
    const confirm = (e) => {
        var token = document.getElementsByName("csrf-token")[0].content;
        fetch(`/admin/clients/${props.client.id}.json`, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": token
            },
            credentials: "same-origin",
        })
        .then(res => {
          window.location.assign('/admin/clients')
        })
      message.success('Click on Yes');
    };
return (
  <Popconfirm
    title={`Delete Client ${props.client.name}`}
    description="Are you sure to delete this Client?"
    onConfirm={confirm}
    okText="Yes"
    cancelText="No"
  >
    <Button danger>Delete</Button>
  </Popconfirm>
);
}
export default DeleteClient;